export const types = {
  ACTIVITY_REQUESTS: 'activityRequests',
  ACTIVITIES: 'activities'
};
